import React, { useEffect, useState, useRef } from "react";
import { notification } from "antd";
import Table from "react-bootstrap/Table";
import { getGruposLab } from "../Services/CatalogosServices";
import { getSpConsultaLabHistorico } from "../Services/ConsultasServices";
import moment from "moment/moment";

export const LaboratoriosView = ({ idPaciente }) => {
  const [idNegocio] = useState(JSON.parse(localStorage.getItem("auth")).id);
  const [api, contextHolder] = notification.useNotification();

  const errorNotificaction = (title, msj) => {
    api.error({
      title: title,
      description: msj,
      duration: 5,
      styles: { root: { backgroundColor: "#FFE4E0" } },
      showProgress: true,
    });
  };

  const initialized = useRef(false);

  // >>>>>>>>>>>>>>>>>>>>>>>>>>>>> PARAMETROS DE ESTADO PARA EL COMPONENTE <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
  const [dataGrupos, setDataGrupos] = useState([]);
  const [dataMarcadoresHistorico, setDataMarcadoresHistorico] = useState([]);
  const [dataResultadosHistorico, setDataResultadosHistorico] = useState([]);

  const fetchGruposLab = async () => {
    try {
      const response = await getGruposLab(idNegocio);
      setDataGrupos(response);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchListaMarcadoresHistorico = async () => {
    try {
      const response = await getSpConsultaLabHistorico(idNegocio, idPaciente);
      const groupedValues = response.map((item) => Object.keys(item));
      setDataMarcadoresHistorico(groupedValues);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  const fetchResultadosHistorico = async () => {
    try {
      const response = await getSpConsultaLabHistorico(idNegocio, idPaciente);
      const groupedValues = response.map((item) => Object.values(item));
      setDataResultadosHistorico(groupedValues);
    } catch (error) {
      errorNotificaction(error.name, error.message);
    }
  };

  useEffect(() => {}, [idPaciente]);

  useEffect(() => {
    fetchGruposLab().then(() => {
      fetchListaMarcadoresHistorico().then(() => {
        fetchResultadosHistorico();
      });
    });
  }, [idPaciente]);

  return (
    <div>
      {contextHolder}
      <div className="row mb-3">
        <div className="col">
          <Table
            bordered
            hover
            responsive
            style={{
              width: "100%",
              cellPadding: "5",
              cellSpacing: "5",
              fontSize: "12px",
            }}
            cellPadding={10}
            cellSpacing={10}
          >
            <thead>
              <tr>
                <th></th>
                {dataGrupos.map((grupo) => (
                  <th
                    colSpan={grupo.marcadores}
                    style={{ fontSize: "14px", textAlign: "center" }}
                  >
                    {grupo.label}
                  </th>
                ))}
              </tr>
              {dataMarcadoresHistorico.map((item, ix) =>
                ix === 0 ? (
                  <tr>
                    {item.map((marcador, index) => (
                      <td
                        key={`marcador-${ix}-${index}`}
                        style={{
                          fontSize: "13px",
                          textAlign: "center",
                          fontWeight: "500",
                        }}
                      >
                        {marcador.toUpperCase()}
                      </td>
                    ))}
                  </tr>
                ) : null,
              )}

              {dataResultadosHistorico.map((item, ix) => (
                <tr>
                  {item.map((valor, index) => (
                    <td
                      key={`valor-${ix}-${index}`}
                      style={{ fontSize: "13px", textAlign: "center" }}
                    >
                      {index === 0
                        ? valor.substring(0, 10)
                        : valor === -1
                          ? "NEG"
                          : valor}
                    </td>
                  ))}
                </tr>
              ))}
            </thead>
          </Table>
        </div>
      </div>
    </div>
  );
};
